import React from 'react';
import { Dialog, DialogTitle, DialogActions, Button, Icon } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { get } from 'global/lib/lodash';

const useStyles = makeStyles(() => ({
  paper: {
    padding: 15,
  },
  actionsContainer: {
    paddingTop: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginRight: 5,
  },
}));

export default (props) => {
  const { useDialog, title, children, onClose, open } = props;
  const classes = useStyles();

  if (useDialog) {
    const includeButtons = get(props, 'includeButtons', true);

    return (
      <Dialog open={open} onClose={onClose} classes={props.classes || { paper: classes.paper }}>
        {title && <DialogTitle>{title}</DialogTitle>}

        {children}

        {includeButtons && (
          <DialogActions classes={{ root: classes.actionsContainer }}>
            <Button onClick={onClose} variant="contained" color="secondary">
              <Icon classes={{ root: classes.icon }}>check</Icon>
              APPLY
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }

  return <div style={{ width: '100%', height: '100%' }}>{children}</div>;
};
